import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/redux';
import { Value, ValueGroupHeading, ValueGroups, Values } from '@fttb/common/components';
import { getTextColor } from "../../../../store/blocks/tariffs/tariffSelectors";
import { getTariffGroupedValues, getValueGroupTitle, withTariffValueGroupMapper } from "../../../../store/blocks/tariffs/valueGroupSelectors";
import { getTariffValueAmount, getTariffValueUnit, withTariffValueMapper } from "../../../../store/blocks/tariffs/valueSelectors";
export var TariffValueGroups = withTariffValueGroupMapper(ValueGroups);
export var TariffValueGroupHeading = compose(connect(function (state) {
  return {
    children: getValueGroupTitle(state),
    shouldRender: getTariffGroupedValues(state).length > 1 && !!getValueGroupTitle(state)
  };
}), withRenderFlag)(ValueGroupHeading);
export var TariffValues = withTariffValueMapper(Values);
export var TariffValue = connect(function (state) {
  return {
    color: getTextColor(state),
    unit: getTariffValueUnit(state),
    value: getTariffValueAmount(state)
  };
})(Value);